export const CLEAR_USER_DATA = 'USER:CLEAR_DATA';
export const RECEIVED_USER_PROFILE = 'USER:RECEIVED_PROFILE';
